export default {
  sizeSmall: "Niedrig",
  sizeMedium: "Mittel",
  sizeLarge: "Groß",
};
